import _ from 'lodash';
import React from 'react';

import './styles.css';

const PENDING_CUSTOMER_APPROVAL = 'pending_customer_approval';
const PENDING_SUBMISSION = 'pending_submission';
const SUBMITTED = 'submitted';
const CONFIRMED = 'confirmed';
const PAID_OUT = 'paid_out';
const CANCELLED = 'cancelled';
const FAILED = 'failed';
const CHARGED_BACK = 'charged_back';
const INITIATE_FAILED = 'initiate_failed';
const PERMANENTLY_FAILED = 'permanently_failed';
const RETRY_FAILED = 'retry_failed';
const CANCEL_FAILED = 'cancel_failed';
const MANUALLY_POSTED = 'manually_posted';
const VOIDED = 'voided';

interface PaymentStatusTagProps {
  status: string;
}

const STATUS_TO_COLOR_MAPPER = {
  [PENDING_CUSTOMER_APPROVAL]: {
    backgroundColor: '#CCEBFF',
    textColor: '#0C6AA6',
    borderColor: '#0C6AA6',
    label: 'Pending Customer Approval'
  },
  [PENDING_SUBMISSION]: {
    backgroundColor: '#A5DCFF',
    textColor: '#0070B9',
    borderColor: '#0070B9',
    label: 'Pending Submission'
  },
  [SUBMITTED]: {
    backgroundColor: '#49EEE9',
    textColor: '#006A67',
    borderColor: '#006A67',
    label: 'Submitted'
  },
  [CONFIRMED]: {
    backgroundColor: '#FFE6C2',
    textColor: '#E96200',
    borderColor: '#FF9626',
    label: 'Confirmed'
  },
  [PAID_OUT]: {
    backgroundColor: '#D4F1CA',
    textColor: '#228100',
    borderColor: '#5FBA3F',
    label: 'Paid out'
  },
  [CANCELLED]: {
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#d2d9e2',
    label: 'Cancelled'
  },
  [FAILED]: {
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444',
    label: 'Failed'
  },
  [VOIDED]: {
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#d2d9e2',
    label: 'Void'
  },
  [MANUALLY_POSTED]: {
    backgroundColor: '#49EEE9',
    textColor: '#006A67',
    borderColor: '#006A67',
    label: 'Manually posted'
  },
  [CHARGED_BACK]: {
    backgroundColor: '#FFE1E1',
    textColor: '#AB4F4F',
    borderColor: '#AB4F4F',
    label: 'Charged back'
  },
  [INITIATE_FAILED]: {
    backgroundColor: '#CAD4DF',
    textColor: '#4A5665',
    borderColor: '#4A5665',
    label: 'Initiate failed'
  },
  [RETRY_FAILED]: {
    backgroundColor: '#CAD4DF',
    textColor: '#4A5665',
    borderColor: '#4A5665',
    label: 'Retry failed'
  },
  [CANCEL_FAILED]: {
    backgroundColor: '#CAD4DF',
    textColor: '#4A5665',
    borderColor: '#4A5665',
    label: 'Cancel failed'
  },
  [PERMANENTLY_FAILED]: {
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444',
    label: 'Permanently Failed'
  }
};

class PaymentStatusTag extends React.Component<PaymentStatusTagProps> {
  static VOIDED = 'voided';

  render() {
    const {status} = this.props;

    let {backgroundColor, textColor, borderColor, label} = _.get(
      STATUS_TO_COLOR_MAPPER,
      status,
      {}
    );

    return (
      <div
        className="PaymentStatusTag colab-centered colab-bold"
        style={{
          backgroundColor,
          borderColor,
          color: textColor
        }}>
        {label}
      </div>
    );
  }
}

export default PaymentStatusTag;
